<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import { t } from "../../helpers/translation";
</script>

<LightTheme />

<Hero headline={$t("page.certificates.hero.headline")} small gray />

<Container small>
    <Headline>
        {@html $t("page.certificates.headline")}
    </Headline>
    <Subline>
        {@html $t("page.certificates.subline")}
    </Subline>

    <Gap height="3em" />
    <div class="zertifikate">
        <Image src="/img/gruenderpreis-2024.jpg" />
        <a
            href="https://liveicom.azureedge.net/sinus/img/zertifikate/motorola-zertifikat-sinus-2024.pdf"
            target="_blank"
        >
            <Image
                src="https://liveicom.azureedge.net/sinus/img/zertifikate/motorola-zertifikat-sinus-2024.jpeg"
            />
        </a>
        <Image
            src="https://liveicom.azureedge.net/sinus/img/zertifikate/ISO-9001-Deutsch.svg"
        />
        <Image
            src="https://liveicom.azureedge.net/sinus/img/zertifikate/avpq.png"
        />
    </div>
</Container>

<style lang="scss">
    @import "./src/vars";

    .zertifikate {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: center;
        gap: 5em;
    }
    // ...
</style>
